import React, { Component } from 'react';
import SelectField from './SelectField';
import Input from './Input';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

class KeyValueInput extends Component {
    _onChangeKey = (value, name) => this.props.onKeyValueInput(name, 'k', this.props.index, value);
    _onChangeValue = (value, name) => this.props.onKeyValueInput(name, 'v', this.props.index, value);
    _onDelete = () => this.props.onDelete(this.props.name, this.props.index);
    render() {
        return (
            <div className="ckp-kv-inputs">
                {this.props.valueValue ? (
                    <span className="ckp-kv-inputs-delete">
                        <IconButton color="inherit" className="ckp-kv-inputs-delete-button" onClick={this._onDelete}>
                            <DeleteIcon style={{ fontSize: '20px' }} />
                        </IconButton>
                    </span>
                ) : null}
                <SelectField
                    withSearch={false}
                    name={this.props.name}
                    onChange={this._onChangeKey}
                    items={this.props.keyOptions}
                    label={this.props.keyLabel}
                    value={this.props.keyValue}
                />
                <Input
                    className="is-full-width"
                    name={this.props.name}
                    onChange={this._onChangeValue}
                    label={this.props.valueLabel}
                    value={this.props.valueValue}
                />
            </div>
        );
    }
}

export default KeyValueInput;
